import React, {Fragment} from 'react';
import ObjectData from "../../dataModel/ObjectData";
import {connect} from "react-redux";
import {sortByNumbersFuncFactory} from '../../utils/aux';
import arrowLeft from '../../resouces/arrow-left.svg'
import arrowRight from '../../resouces/arrow-right.svg'
import avatarPlaceholder from '../../resouces/placeholder-300.png'
import Localization from "../../localization";


class RelatedObjectList extends React.Component {

    renderChild(child, selectedLanguage, withAvatar) {
        const isLocked = child.needUnlock

        if (withAvatar) {
            const avatarImg = child.avatarImage ? 'data:image/jpeg;base64,' + child.avatarImage : avatarPlaceholder;
            const href = (window.location.href.includes('/play/') ? "/play/?" : "/?") + child.objectId

            return (
                <a href={ isLocked ? null : href }
                   onClick={ isLocked ? () => {alert(Localization.stringFor("contentLocked"))} : null }
                   className="NavigationChildLink"
                   key={child.objectId + "_RelatedItem"}>

                    <div className='NavigationChildBlockWithAvatar'>
                        {
                            isLocked &&
                            <i className="LockedIconOnAvatar fas fa-lock" />
                        }

                        <img className='NavigationChildAvatar'
                             src={avatarImg}
                             alt="Child object"/>
                        {child.description(selectedLanguage)}

                    </div>
                </a>
            )
        }

        return (
            <a href={(window.location.href.includes('/play/') ? "/play/?" : "/?") + child.objectId}
               key={child.objectId + "_RelatedItem"}>
                <div className='NavigationChildBlock'>
                    <img className='NavigationArrow' src={arrowRight} alt="Go next"/>

                    <div>
                        {child.description(selectedLanguage)}
                    </div>
                </div>

            </a>
        )
    }

    renderChildren() {
        const {object, selectedLanguage} = this.props;
        const withAvatar = object.isContainerObject;

        return <div className={withAvatar ? "NavigationChildContainer" : ""}>
            {
                object.childrenList
                    .sort(sortByNumbersFuncFactory(it => it.description(selectedLanguage)))
                    .sort((a, b) => {
                        if (a.comment > b.comment) {
                            return 1
                        }
                        if (a.comment < b.comment) {
                            return -1
                        }
                        return 0
                    })
                    // .sort((a, b) => {
                    //     const aVal = a.comment ? parseInt(a.comment) : 99999
                    //     const bVal = b.comment ? parseInt(b.comment) : 99999
                    //
                    //     return aVal-bVal
                    // })
                    .map(child =>
                        this.renderChild(child, selectedLanguage, withAvatar)
                    )
            }
        </div>
    }

    render() {
        const {object, selectedLanguage} = this.props;
        if (!object) return null;

        const relatedObjects = object.relatedObjectMedias.map(it => {
            const relObj = new ObjectData(object.relatedObjectList.find(ob => ob.objectId === it.tags.RelatedObjectId));
            relObj.tags.RelationType = it.tags.RelationType;
            return relObj;
        });

        return (
            <Fragment>

                {
                    (!object.isContainerObject && (relatedObjects.length > 0 || object.childrenList)) &&
                        <div className='space25'/>
                }


                {
                    relatedObjects.map(item => {

                        return (
                            <a href={(window.location.href.includes('/play/') ? "/play/?" : "/?") + item.objectId + "&" + object.objectId} key={item.objectId + "_RelatedItem"}>
                                <div className='NavigationChildBlock'>
                                    <img className='NavigationArrow' src={arrowRight} alt="Go next"/>

                                    <div>
                                        {item.description(selectedLanguage)}
                                    </div>
                                </div>
                            </a>
                        )
                    })
                }


                {
                    object.childrenList &&
                        this.renderChildren()
                }


                {
                    object.parentList &&
                        object.parentList.map((parent, i) =>
                            <a href={(window.location.href.includes('/play/') ? "/play/?" : "/?") + parent.objectId}
                               key={parent.objectId + "_RelatedItem"}>

                                <div className='ContentDelimiterGreen'
                                    style={
                                        {
                                            marginTop: `${ (i > 0) ? 1 : "initial" }vw`,
                                            paddingLeft: `${3 + i * 10}vw`,
                                            width: `${100 - (6 + i * 10)}vw`
                                        }
                                    }>
                                    <img className='NavigationArrow' src={arrowLeft} alt="Go back"/>

                                    <div>
                                        {parent.description(selectedLanguage)}
                                    </div>
                                </div>
                            </a>
                        )
                }


            </Fragment>
        )
    }
}


const mapStateToProps = ({selectedLanguage}) => ({selectedLanguage});
export default connect(mapStateToProps)(RelatedObjectList);
